import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { throwError, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ErrorType } from '../models/error-type.model';

import { TokenClient } from './tvp-client';

const tokenKey = 'token';

@Injectable({
  providedIn: 'root',
})
export class TokenAuthService {
  private _token: string | undefined;
  private readonly jwtService: JwtHelperService;

  constructor(private tokenClient: TokenClient) {
    this.jwtService = new JwtHelperService();
  }

  get hasToken(): boolean {
    return !!this._token;
  }

  get token(): string | undefined {
    return this._token;
  }

  get claims(): any {
    return this.jwtService.decodeToken(this._token);
  }

  clear(): void {
    this._token = undefined;
  }

  createToken(next: ActivatedRouteSnapshot): Observable<boolean> {
    if (next.queryParams[tokenKey] && next.queryParams[tokenKey].length > 0) {
      const orderToken = next.queryParams[tokenKey];
      return this.tokenClient.createToken({ token: orderToken }, true).pipe(
        map((token) => {
          this._token = token.jwtToken;
          return true;
        })
      );
    }

    return throwError(ErrorType.NoToken);
  }
}
